import React from 'react';
interface TargetProgressBarProps {
  // Real value and target, in the same unit (amount or percentage)
  actual: number;
  target: number;
  // Solid colour class of the real value, e.g. "bg-green-600"
  colorClass: string;
  // Scale of the bar: defaults to the larger of actual and target
  max?: number;
  height?: 'sm' | 'md';
  label?: string;
}

/**
 * Horizontal bar comparing the real value (solid) with the target
 * (same colour, reduced opacity, plus a thin marker at the target point).
 */
export function TargetProgressBar({
  actual,
  target,
  colorClass,
  max,
  height = 'md',
  label
}: TargetProgressBarProps) {
  const scale = max ?? Math.max(actual, target, 1);
  const pct = (v: number) => `${Math.min(100, Math.max(0, v / scale * 100))}%`;
  const h = height === 'sm' ? 'h-2' : 'h-2.5';
  return <div className={`relative w-full bg-slate-100 rounded-full ${h}`} role="img" aria-label={label} data-id="element-1845" data-mp="38upkgh6rbc2c">
      <div className={`absolute inset-y-0 left-0 rounded-full opacity-30 ${colorClass}`} style={{
      width: pct(target)
    }} data-id="element-1846" data-mp="34tvrvaidd934" />
      <div className={`absolute inset-y-0 left-0 rounded-full ${colorClass}`} style={{
      width: pct(actual)
    }} data-id="element-1847" data-mp="2310dgne6mzu9" />
      <div className={`absolute -top-1 -bottom-1 w-0.5 rounded-full opacity-60 ${colorClass}`} style={{
      left: `calc(${pct(target)} - 1px)`
    }} data-id="element-1848" data-mp="27zuvhn4bskdb" />
    </div>;
}